// unmanaged
// Calls behind the Projects pages (docs/project-tracking.md). Reads go
// through POST /project-request actions; writes through the project and
// project-entry routes.
import apiClient from "../utils/apiClient";

const request = (action, payload = {}) => apiClient.post("/project-request", { action, ...payload });

export const fetchMeta = async () => (await request("meta")).records[0];

// The caller's company's tags (any role): { metadata: { available }, records }.
export const fetchTags = () => request("tags");

export const fetchCandidates = async (id) => (await request("candidates", { id })).records[0];

export const linkItems = (id, { runIds = [], inputIds = [] }) =>
  request("link", { id, run_ids: runIds, input_ids: inputIds });

export const unlinkItems = (id, { runIds = [], inputIds = [] }) =>
  request("unlink", { id, run_ids: runIds, input_ids: inputIds });

export const mergeProject = (id, fromId) => request("merge", { id, from_id: fromId });

export const fetchDashboard = (statuses, companyId) =>
  request("dashboard", { ...(statuses ? { statuses } : {}), ...(companyId ? { company_id: companyId } : {}) });

export const fetchCompanyProjects = (companyId) => request("dashboard", { company_id: companyId });

export const fetchProject = async (id) => (await request("by_id", { id })).records[0];

export const setMilestone = async (id, milestone, completed) =>
  (await request("set_milestone", { id, milestone, completed })).records[0];

export const createProject = (body) => apiClient.post("/project", body);

export const updateProject = (id, patch) => apiClient.put(`/project/${encodeURIComponent(id)}`, patch);

export const deleteProject = (id) => apiClient.delete(`/project/${encodeURIComponent(id)}`);

export const addNote = (projectId, comment) => apiClient.post("/project-entry", { project_id: projectId, comment });

export const deleteNote = (id) => apiClient.delete(`/project-entry/${encodeURIComponent(id)}`);

// Regroup uploads and runs: staff by project ID (null = out of every project),
// customers by tag. withRuns also moves the runs made from the uploads.
export const moveItems = ({ projectId, projectTag, inputIds = [], runIds = [], withRuns = false, staff }) =>
  request("move", {
    ...(staff ? { project_id: projectId || null } : { project_tag: projectTag || null }),
    input_ids: inputIds,
    run_ids: runIds,
    with_runs: withRuns,
  });
